import { all, call, fork, put, takeEvery, select } from 'redux-saga/effects';
import { Map } from 'immutable';

// action creators
import { success, doneIndicator } from 'store/actions/httpActions';

// selectors
import getCurrentGroupId from 'store/selectors/getCurrentGroupId';

// api
import client from 'sources/api';

// constants
import {
  LEAD_REFERRAL_SOURCE_DELETE_REQUEST,
  LEAD_REFERRAL_SOURCE_DELETE,
} from 'store/constants/leadReferralSourceTypes';

// schemas
import { leadReferralSourceSchema } from 'store/schemas/leadReferralSourceSchema';

// helpers
import httpSaga from 'store/sagas/httpSaga';
import getSliceEntityById from 'store/selectors/getSliceEntityById';

const WATCH_TYPE = LEAD_REFERRAL_SOURCE_DELETE_REQUEST;
const TYPE = LEAD_REFERRAL_SOURCE_DELETE;

export function* deleteLeadReferralSource(action: any) {
  const {
    payload: { referralSourceId, leadId },
  } = action;
  const currentGroupId = yield select(getCurrentGroupId);
  const leadReferralSources = yield select(
    getSliceEntityById('leadReferralSource', leadId)
  );
  const id = leadReferralSources[referralSourceId].id;

  // @ts-expect-error ts-migrate(2569) FIXME: Type 'Generator<any, any, unknown>' is not an arra... Remove this comment to see the full error message
  yield* httpSaga(
    TYPE,
    call(
      client.delete,
      `/pnm_referral_sources/${id}?group_id=${currentGroupId}`
    ),
    {
      dispatchSuccess: false,
      schema: leadReferralSourceSchema,
      metaId: leadId,
    }
  );
  yield put(
    success(TYPE, Map({ id: leadId, subId: referralSourceId }), leadId)
  );
  yield put(doneIndicator(TYPE));
}

export function* watch() {
  yield takeEvery(WATCH_TYPE, deleteLeadReferralSource);
}

export default function* root() {
  yield all([fork(watch)]);
}
